<template>
  <div class="agent-notice" v-if="visible">
    <div class="notice-wrapper">
      <div class="notice-content">
        <span> {{res.tips}} </span>
        <vktimezone :open-check="true" />
        <br/>
        <span>{{res.parentId}} {{this.parentId}}, {{res.studentId}} {{this.studentId}}</span>
      </div>
      <vkbutton class="notice-btn" @click="agentExit"> {{res.exit}} </vkbutton>
    </div>
  </div>
</template>

<style lang="less">
@import "@/styles/common.less";

.agent-notice {
  @keyframes colorChange {
    0% { background: #ECA7CE; }
    33% { background: #89CCDF; }
    66% { background: #B2B2E8; }
    100% { background: #ECA7CE; }
  }
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  // height: 1.2rem;
  color: #fff;
  font-size: 0.2rem;
  font-weight: bold;
  z-index: @ZINDEX_COVER - 5;
  animation: colorChange 3S infinite;
  .notice-wrapper {
    width: 10.8rem;
    padding: 0.2rem 0;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .notice-content {
      line-height: 0.4rem;
      .vktimezone {
        display: contents;
        color: #fff;
        font-size: 0.2rem;
      }
    }
    .notice-btn{
      color: #fff;
      background: none;
      border-color: #fff;
    }
  }
}
</style>

<script>
import { hobbitComponent } from 'hobbit-base';
import vkbutton from '../vkbutton/vkbutton.vue';
import vktimezone from '../vktimezone/vktimezone.vue';

export default hobbitComponent({
  name: 'agentNotice',
  components: {
    vkbutton,
    vktimezone,
  },
  data() {
    return {
      visible: false,
      parentId: '',
      studentId: '',
    };
  },
  async created() {
    // agentInfo有值时才展示组件
    this.agentInfo = this.$ctx.agentInfo;
    if (this.agentInfo) {
      this.visible = true;
      this.parentId = this.$user.vkUserId();
      this.studentId = this.$user.vkStudentId();
    }
    // 监听localStorage
    window.addEventListener('storage', (event) => {
      // agentInfo信息发生变化时，关闭当前页面
      if (event.key === 'agentInfo') {
        window.close();
        // 当window.close未生效时,刷新页面
        this.$app.pageReload();
      }
    });
  },
  methods: {
    // 退出操作，清除agentInfo信息
    agentExit() {
      this.$ctx.setAgentInfo(null);
      this.$user.logout();
      window.close();
    },
  },
});
</script>
